import './Title.css';

// Banner compacto das páginas internas (Sobre, Contato, Termos, Política, Eventos).
export default function Title({ children }: { children: React.ReactNode }) {
  return (
    <section className="cz-title cz-scope">
      <div className="cz-title__inner">
        <h1 className="cz-title__heading">{children}</h1>
        <div className="cz-title__shapes" aria-hidden="true">
          <span className="cz-shape cz-shape--drop cz-title__drop" />
          <span className="cz-shape cz-shape--orb cz-title__orb" />
        </div>
      </div>
    </section>
  );
}
